export default "__VITE_ASSET__Bwjxb1_U__$_?url__"